export default "__VITE_ASSET__BsbC_S_8__"